// Contenu statique du site Nerolya Cosmetic.
// Les IMAGES sont des photos de banque d'images (placeholders).
// Remplacez simplement les URLs ci-dessous par vos propres visuels plus tard.

export const IMAGES = {
  heroHome: "/images/site-hero.png",
  heritage1: "/images/site-artisane.png",
  heritage2: "/images/site-roses.png",
  nature: "/images/site-roses.png",
  histoireHero: "/images/site-artisane.png",
  ethiqueHero: "/images/site-roses.png",
  ingredientsHero: "/images/site-ingredients.png",
  cooperativesHero: "/images/site-artisane.png",
  contactHero: "/images/site-portrait.png",
  boutiqueHero: "/images/site-ingredients.png",
  splitArgan: "/images/products/huile-argan-bio-1.png",
  splitWomen: "/images/site-artisane.png",
  splitAtlas: "/images/site-roses.png",
  fidelite: "/images/site-portrait.png",
};

export const NAV_LINKS = [
  { label: "Accueil", to: "/" },
  { label: "Boutique", to: "/collections/all" },
  { label: "Héritage", to: "/pages/notre-histoire" },
  { label: "Éthique", to: "/pages/notre-ethique" },
  { label: "Contact", to: "/pages/contact" },
];

export const ANNOUNCEMENTS = [
  "Livraison offerte dès 45 € · Belgique & France",
  "Ingrédients certifiés bio ECOCERT · Formulés au Maroc",
  "Paiement sécurisé · Bancontact · Visa · Mastercard",
];

export const REASSURANCE = [
  "Livraison offerte dès 45€",
  "100% Bio Certifié",
  "Retours gratuits 30 jours",
  "Paiement sécurisé",
];

export const STATS = [
  { number: "7", label: "Ingrédients actifs purs" },
  { number: "4", label: "Coopératives partenaires" },
  { number: "98%", label: "Clientes satisfaites" },
  { number: "0", label: "Additifs synthétiques" },
];

export const REVIEWS = [
  {
    text: "L'huile d'Argan a transformé ma peau en moins de deux semaines. Une texture soyeuse, une absorption instantanée et un éclat que je n'avais jamais eu. Je ne reviendrai plus en arrière.",
    author: "Sophie M.",
    place: "Bruxelles · Achat vérifié",
  },
  {
    text: "Le savon noir beldi est une révélation. Le rituel hammam chez soi — j'en rêvais. La peau est incroyablement douce après. Le packaging est d'une élégance rare.",
    author: "Camille D.",
    place: "Paris · Achat vérifié",
  },
  {
    text: "L'eau de rose est mon nouveau must-have. Naturelle, parfumée avec délicatesse, apaisante sur ma peau sensible. Je commande désormais en double pour ne jamais être à court.",
    author: "Amira K.",
    place: "Lyon · Achat vérifié",
  },
];

export const SERVICES = [
  { title: "Livraison offerte", desc: "Dès 45€ d'achat vers la Belgique et la France. Livraison en 2–4 jours ouvrés." },
  { title: "Paiement sécurisé", desc: "Transactions chiffrées SSL via Stripe. Carte bancaire acceptée en toute confiance." },
  { title: "Retours 30 jours", desc: "Satisfaite ou remboursée. Retours gratuits sous 30 jours sans justification requise." },
  { title: "Conseil personnalisé", desc: "Notre équipe répond en moins de 24h. Diagnostic de peau offert par messagerie." },
];

export const INGREDIENTS = [
  { name: "Huile d'Argan", origin: "Sud marocain", desc: "L'« or liquide » des femmes berbères, riche en vitamine E, pour une hydratation profonde." },
  { name: "Figue de Barbarie", origin: "Vallées du Sud", desc: "L'huile anti-âge la plus précieuse au monde, concentrée en antioxydants." },
  { name: "Rose de Damas", origin: "Vallée des Roses", desc: "Distillée à la vapeur, tonifiante et apaisante pour tous types de peaux." },
  { name: "Rhassoul", origin: "Moyen Atlas", desc: "Argile volcanique purifiante, alternative naturelle aux nettoyants agressifs." },
  { name: "Fleur d'Oranger", origin: "Plaines de Marrakech", desc: "Le néroli, signature de la Maison, illumine et réconforte l'épiderme." },
  { name: "Nigelle", origin: "Régions du Rif", desc: "La « graine bénie », apaisante et purifiante pour les peaux à imperfections." },
  { name: "Karité brut", origin: "Commerce équitable", desc: "Beurre baratté à la main, nutrition intense et réparatrice." },
];

export const FAQ = [
  { q: "Vos produits sont-ils vraiment 100% bio ?", a: "Oui. Toutes nos formules sont certifiées Cosmos Organic et composées d'ingrédients issus de l'agriculture biologique, sans parabènes, sans silicones, sans perturbateurs endocriniens." },
  { q: "Vos produits sont-ils testés sur les animaux ?", a: "Jamais. Nerolya Cosmetic est certifiée Cruelty-free et vegan. Aucun de nos produits ni ingrédients n'est testé sur les animaux." },
  { q: "Quels sont les délais de livraison ?", a: "Vos commandes sont préparées sous 24 à 48h et livrées en 2 à 4 jours ouvrés en Belgique et en France. La livraison est offerte dès 45€ d'achat." },
  { q: "Puis-je retourner un produit ?", a: "Oui, vous disposez de 30 jours pour nous retourner gratuitement un produit, ouvert ou non, et être intégralement remboursée." },
  { q: "Comment conserver mes huiles ?", a: "À l'abri de la lumière et de la chaleur. Nos huiles pressées à froid se conservent 12 mois après ouverture." },
  { q: "Proposez-vous des conseils personnalisés ?", a: "Absolument. Notre équipe réalise un diagnostic de peau offert par messagerie et vous oriente vers le rituel le plus adapté en moins de 24h." },
];

export const BLOG = [
  {
    slug: "rituel-hammam-maison",
    category: "Rituels",
    title: "Le rituel du hammam, à recréer chez soi",
    date: "12 janvier 2026",
    image: "/images/site-hammam.png",
    excerpt: "Savon noir, gant de kessa, rhassoul puis huile d'argan : découvrez les quatre étapes d'un véritable rituel hammam, pour une peau neuve et lumineuse.",
    content: [
      "Le hammam est bien plus qu'un bain : c'est un moment suspendu, un rituel de purification transmis depuis des siècles au Maroc. Bonne nouvelle, ses bienfaits se recréent aisément dans votre salle de bain.",
      "Étape 1 — Le savon noir beldi. Sur peau humide et réchauffée par la vapeur, appliquez une noix de savon noir et laissez poser cinq minutes. Riche en vitamine E, il prépare la peau au gommage.",
      "Étape 2 — Le gommage au gant de kessa. Frottez par mouvements circulaires : les cellules mortes s'éliminent, la peau retrouve sa douceur et sa luminosité.",
      "Étape 3 — Le masque au rhassoul. Cette argile volcanique purifie en douceur, resserre les pores et rééquilibre la peau sans l'agresser.",
      "Étape 4 — L'hydratation à l'huile d'argan. Pour sceller le rituel, quelques gouttes d'or liquide nourrissent intensément l'épiderme. La peau est repulpée, soyeuse, éclatante.",
    ],
  },
  {
    slug: "huile-argan-bienfaits",
    category: "Ingrédients",
    title: "L'huile d'argan : tout savoir sur l'or des Berbères",
    date: "28 décembre 2025",
    image: "/images/products/huile-argan-bio-1.png",
    excerpt: "Hydratation, anti-âge, cheveux, ongles… Pourquoi l'huile d'argan est-elle l'ingrédient star de la beauté marocaine ? Décryptage.",
    content: [
      "Surnommée « l'or liquide », l'huile d'argan est extraite des amandons de l'arganier, un arbre endémique du sud-ouest marocain. Sa production, encore largement artisanale, mobilise des coopératives de femmes berbères.",
      "Exceptionnellement riche en vitamine E et en acides gras essentiels, elle nourrit la peau en profondeur tout en la protégeant du vieillissement prématuré causé par les radicaux libres.",
      "Polyvalente, elle s'utilise sur le visage, le corps, les cheveux et même les ongles. Sa texture sèche pénètre rapidement sans laisser de fini gras — idéale matin et soir.",
      "Notre conseil : appliquez 3 à 4 gouttes sur peau propre le soir, en massant par mouvements ascendants. En masque capillaire, laissez poser 30 minutes avant le shampooing.",
    ],
  },
  {
    slug: "rose-de-damas-secret",
    category: "Ingrédients",
    title: "Eau de rose de Damas : le secret d'un teint frais",
    date: "10 décembre 2025",
    image: "/images/products/eau-de-rose-pure-1.png",
    excerpt: "Tonique, apaisante, parfumée : l'eau de rose de Damas est le geste beauté minute des Marocaines. Voici comment l'intégrer à votre routine.",
    content: [
      "Chaque printemps, la Vallée des Roses du Dadès se couvre de fleurs cueillies à la main avant le lever du soleil. Distillée à la vapeur, la rose de Damas donne une eau florale précieuse au parfum délicat.",
      "Tonifiante, elle resserre les pores et ravive l'éclat du teint. Apaisante, elle calme les peaux sensibles et réactives.",
      "Utilisez-la en brume rafraîchissante au réveil, en lotion après le nettoyage, ou pour parfaire votre démaquillage sur un coton.",
      "Un geste simple, un résultat immédiat : une peau fraîche, parfumée et confortable tout au long de la journée.",
    ],
  },
];

export const LEGAL = {
  "mentions-legales": {
    title: "Mentions légales",
    blocks: [
      { h: "Éditeur du site", p: "Nerolya Cosmetic SRL — Société de cosmétique naturelle. Siège social : Rue des Artisans 12, 1000 Bruxelles, Belgique. TVA : BE0123.456.789. Email : contact@nerolyacosmetic.com." },
      { h: "Directeur de la publication", p: "La représentante légale de Nerolya Cosmetic SRL." },
      { h: "Hébergement", p: "Le site est hébergé sur une infrastructure cloud sécurisée au sein de l'Union Européenne." },
      { h: "Propriété intellectuelle", p: "L'ensemble des contenus (textes, visuels, logos) est la propriété exclusive de Nerolya Cosmetic SRL et ne peut être reproduit sans autorisation." },
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    blocks: [
      { h: "Données collectées", p: "Nous collectons uniquement les données nécessaires au traitement de vos commandes et à l'envoi de notre newsletter : nom, adresse email, adresse de livraison." },
      { h: "Utilisation des données", p: "Vos données servent exclusivement à la gestion de vos commandes, au service client et, avec votre accord, à l'envoi d'informations commerciales." },
      { h: "Vos droits (RGPD)", p: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Contactez-nous à contact@nerolyacosmetic.com." },
      { h: "Conservation", p: "Vos données sont conservées le temps strictement nécessaire puis supprimées de nos systèmes de manière sécurisée." },
    ],
  },
  cgu: {
    title: "Conditions générales de vente",
    blocks: [
      { h: "Objet", p: "Les présentes CGV régissent les ventes de produits Nerolya Cosmetic effectuées via notre boutique en ligne." },
      { h: "Prix", p: "Les prix sont indiqués en euros, toutes taxes comprises. Nerolya Cosmetic se réserve le droit de modifier ses prix à tout moment." },
      { h: "Paiement", p: "Le paiement s'effectue en ligne de manière sécurisée via Stripe (carte bancaire). La commande est validée après confirmation du paiement." },
      { h: "Livraison & rétractation", p: "Livraison en 2–4 jours ouvrés. Vous disposez d'un droit de rétractation de 30 jours à compter de la réception de votre commande." },
    ],
  },
  cookies: {
    title: "Politique de cookies",
    blocks: [
      { h: "Qu'est-ce qu'un cookie ?", p: "Un cookie est un petit fichier déposé sur votre appareil afin d'améliorer votre expérience de navigation." },
      { h: "Cookies utilisés", p: "Nous utilisons des cookies strictement nécessaires au fonctionnement du site (panier) ainsi que des cookies de mesure d'audience anonymisés." },
      { h: "Gestion", p: "Vous pouvez à tout moment configurer votre navigateur pour refuser les cookies. Certaines fonctionnalités, comme le panier, pourraient alors être limitées." },
    ],
  },
};
